<template>
  <div id="audit" style="font-size: 18px">
    <div class="header flex_btw">
      <div class="flex" style="line-height: 36px">
        <p style="font-size: 24px; font-weight: 500">
          <span>{{ script_info.works_name }}</span>
        </p>
        <div class="flex" v-if="authority.indexOf('6') == -1">
          <span style="font-size: 24px; font-weight: 500">{{
            script_info.is_second ? "(二次)" : "(一次)"
          }}</span>
          <p
            class="fontSize"
            style="color: #1c94c4"
            v-if="
              (script_info.is_edit == 0 ||
              script_info.status == 1 ||
              script_info.status == 2)&&!cutFlag
            "
          >
            审核中
          </p>
          <p
            class="fontSize"
            style="color: #ffc107"
            v-else-if="(script_info.is_edit == 1 && script_info.status == 4)&&!cutFlag"
          >
            建议修改
          </p>
          <!-- 审核不需要，协会保留 -->
          <p v-else-if="(script_info.status == 3 && script_info.is_edit == 2)&&!cutFlag">
            <span style="color: #01ff70" class="fontSize">已备案</span>
            <span class="ml_20"
              >中娱协报审备案号【{{ script_info.cert_no }}】</span
            >
            <a class="ml_20" @click="openQrcode(script_info.qrcode_url)"
              >下载认证二维码</a
            >
          </p>
          <p
            class="fontSize"
            style="color: #a71d2a"
            v-else-if="(script_info.is_edit == 2 && script_info.status == 4)&&!cutFlag"
          >
            已驳回
          </p>
          <p
            class="fontSize"
            style="color: red"
            v-else-if="script_info.status == 5&&!cutFlag"
          >
            放弃审核
          </p>
          <p v-if="script_info.is_second&&!paramsVal.is_finish" style="margin-left: 15px">
          <a-button @click="cutBtn">查看一次剧本详情</a-button>
        </p>
        <p v-if="!script_info.is_second&&!paramsVal.is_finish&&cutFlag" style="margin-left: 15px">
          <a-button @click="cutBtn">返回二次剧本详情</a-button>
        </p>
        </div>
      </div>
      <a-space>
        <a-button type="primary" @click="goback" style="margin: auto 0"
          >返回列表</a-button
        >
        <a-button
          v-if="!paramsVal.type && viewDatas.show_label == 1"
          type="primary"
          @click="get_label_list('get')"
          style="margin: auto 0"
        >
          适龄建议
        </a-button>
        <a-button
          v-if="
            !paramsVal.type &&
            (viewDatas.is_labels == 0 || viewDatas.is_labels == 2)
          "
          type="primary"
          @click="finishBtn"
          style="margin: auto 0"
          >审核完成</a-button
        >
        <a-modal
          title="请确认该产品是否审核完成？"
          :visible="setModal1"
          width="300px"
          :confirm-loading="confirmLoading"
          @ok="finishApi"
          @cancel="setModal1 = false"
        >
          <p>
            合议总数量：<span>{{ specialist_number.total }}</span>
          </p>
          <p>
            新增：<span>{{ specialist_number.add }}</span>
          </p>
          <p>
            修改：<span>{{ specialist_number.edit }}</span>
          </p>
          <p>
            删除：<span>{{ specialist_number.delete }}</span>
          </p>
        </a-modal>
        <a-modal
          title="适龄建议"
          :visible="setModal"
          width="500px"
          :confirm-loading="confirmLoading"
          @ok="get_label_list('upload')"
          @cancel="setModal = false"
        >
          <div v-if="ageLabel.length">
            <p style="margin: 10px 0">适龄标签：</p>
            <a-radio-group name="radioGroup" v-model="ageArr">
              <a-radio
                :value="item.id"
                v-for="item in ageLabel"
                style="margin: 0 10px"
              >
                {{ item.label_name }}
              </a-radio>
            </a-radio-group>
            <!-- <a-checkbox-group @change="onChange" style="margin-top:10px">
              <a-row type="flex">
                <a-col v-for="item in ageLabel" >
                  <a-checkbox :value="item.id">
                    
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group> -->
          </div>
          <div v-if="classifyArr.length">
            <p style="margin: 10px 0">归类标签：</p>
            <a-checkbox-group @change="onChange1" style="margin-top: 10px">
              <a-row type="flex">
                <a-col v-for="item in classifyArr" style="margin: 0 10px">
                  <a-checkbox :value="item.id">
                    {{ item.label_name }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>
          <div>
            <p style="margin: 10px 0">适龄备注：</p>
            <a-textarea
              v-model="remarkVal"
              placeholder="请输入备注"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </div>
        </a-modal>
      </a-space>
    </div>

    <a-row style="height: calc(100% - 70px); border-top: 1px solid #e8e8e8">
      <a-col :span="authority.indexOf('6') == -1 ? 18 : 24">
        <Drama
          :key="reloadDate"
          ref="drama"
          :page="'audit'"
          v-if="viewDatas"
          :viewData="viewDatas"
          :violate="[...botAudit, ...audit]"
          :isSelect="true"
          :audit_5="audit5"
          :paramsVal="paramsVal"
          @setAudit="getAudit"
          @changeTabs="changeTabs"
          @cutSubTab="cutSubTab"
          :authority="authority"
          :isAuthority="isAuthority"
          :specialist_edit="specialist_edit"
        />
      </a-col>
      <a-col
        :span="6"
        style="border-left: 1px solid #e8e8e8"
        v-if="authority.indexOf('6') == -1"
      >
        <div class="title flex_btw">
          <span>审核信息</span
          ><!-- <a-button
            type="primary"
            
            @click="$router.go(-1)"
            style="margin: auto 0"
            >返回列表</a-button
          > -->
        </div>
        <!-- 质检审核内容 -->
        <div style="padding: 15px; overflow-y: auto; height: calc(100% - 70px)">
          <a-card
            v-if="
              script_info.is_second && script_info.quality_second_comments
                ? true
                : !script_info.is_second && script_info.quality_comments
                ? true
                : false
            "
            hoverable
            size="small"
            class="mb_20"
          >
            <span slot="title">
              {{
                script_info.quality_second_comments
                  ? "质检"
                  : script_info.quality_comments
                  ? "质检"
                  : script_info.organization_second_comments
                  ? "机构"
                  : "机构"
              }}审核意见
            </span>
            {{
              script_info.quality_second_comments
                ? script_info.quality_second_comments
                : script_info.quality_comments
                ? script_info.quality_comments
                : script_info.organization_second_comments
                ? script_info.organization_second_comments
                : script_info.organization_comments
            }}
          </a-card>
          <a-button v-if="!paramsVal.type" style="margin-bottom: 15px" type="primary" @click="showSug"
            >整体审核建议</a-button
          >
          <a-card
            v-if="
              script_info.is_second && script_info.specialist_second_suggest
                ? true
                : !script_info.is_second && script_info.specialist_first_suggest
                ? true
                : false
            "
            hoverable
            size="small"
            style="margin-bottom: 15px"
            title="整体审核建议"
          >
            <p style="font-size: 24px">
              {{
                script_info.is_second
                  ? script_info.specialist_second_suggest
                  : script_info.specialist_first_suggest
              }}
            </p>
          </a-card>
          <a-card hoverable size="small" title="人工审核">
            <a-list item-layout="vertical" :data-source="audit">
              <a-list-item
                slot="renderItem"
                slot-scope="item, index"
                style="position: relative"
              >
                <div style="margin-bottom: 5px">
                  <p v-if="item.type == 1 || item.type == 5">
                    <span>内容：</span>
                    <span style="position: relative">{{ item.content }} </span>
                  </p>
                  <p
                    v-else
                    @click="
                      showModal(
                        item.content_html ? item.content_html : item.content
                      )
                    "
                  >
                    <span>内容：</span
                    ><a>{{
                      isHttp(item.content) == "img"
                        ? "点击查看图片"
                        : isHttp(item.content) == "mp4"
                        ? "点击查看图片"
                        : "点击查看音频"
                    }}</a>
                  </p>
                </div>
                <p style="margin-bottom: 5px">
                  <span>异常类型：</span
                  >{{
                    item.quality_type_name
                      ? item.quality_type_name
                      : item.unusual_type_name
                  }}
                </p>
                <p style="margin-bottom: 5px">
                  <span>备注：</span
                  >{{ item.quality_note ? item.quality_note : item.note }}
                </p>
                <div
                  style="background: #f1f1f1; padding: 5px; margin-bottom: 10px"
                  v-if="item.specialist_result != 0"
                >
                  <p style="margin-bottom: 5px">
                    <span class="tips">合议类型：</span>
                    <span style="color: #f59a23">{{
                      item.specialist_result == 3
                        ? "建议新增"
                        : item.specialist_result == 1
                        ? "建议修改"
                        : "建议删除"
                    }}</span>
                  </p>
                  <p
                    style="margin-bottom: 5px"
                    v-if="item.specialist_result == 1"
                  >
                    <span class="tips">异常类型：</span
                    >{{ item.specialist_type_name }}
                  </p>
                  <p
                    style="margin-bottom: 5px"
                    v-if="item.specialist_result == 1"
                  >
                    <span class="tips">备注：</span>{{ item.specialist_note }}
                  </p>
                  <p style="margin-bottom: 5px">
                    <span class="tips">修改原因：</span>
                    <span style="color: #f59a23">{{
                      item.discussion_note
                    }}</span>
                  </p>
                </div>
                <p
                  v-if="
                    !paramsVal.type &&
                    item.showBtn &&
                    viewDatas.is_labels != 1 &&
                    item.specialist_result != 3
                  "
                  style="margin: 10px 0; text-align: right"
                >
                  <a-button
                    v-if="item.specialist_result == 1"
                    @click="editModal(item, index)"
                    style="margin: 0 10px"
                    type="primary"
                    >修改</a-button
                  >
                  <a-button
                    v-if="
                      item.specialist_result != 3 && item.specialist_result != 0
                    "
                    @click="del_content(item, index)"
                    type="danger"
                    style=""
                    >删除</a-button
                  >
                  <a-button
                    v-if="
                      item.specialist_result != 1 && item.specialist_result != 2
                    "
                    @click="editModal(item)"
                    style="margin: 0 10px"
                    type="primary"
                    >合议</a-button
                  >
                </p>
                <p
                  v-if="
                    !paramsVal.type && item.showBtn && viewDatas.is_labels != 1
                  "
                  style="margin: 10px 0; text-align: right"
                >
                  <a-button
                    @click="editModal(item, 'specialist')"
                    style="margin: 0 10px"
                    v-if="item.specialist_result == 3"
                    type="primary"
                    >修改</a-button
                  >
                  <a-button
                    v-if="item.specialist_result == 3"
                    @click="del_check(item, index)"
                    type="danger"
                    style=""
                    >删除</a-button
                  >
                </p>
              </a-list-item>
            </a-list>
          </a-card>
        </div>
      </a-col>
    </a-row>

    <!-- 图片弹窗 -->
    <imgModal :flag="previewVisible" :imgUrl="previewImage" @changes="flags" />

    <!-- 整体审核建议弹窗 -->
    <a-modal
      title="请对该作品提出整体审核建议"
      :visible="sugModal"
      width="350px"
      :confirm-loading="confirmLoading"
      @ok="suggestApi"
      @cancel="(sugModal = false), (sugVal = '')"
    >
      <a-textarea v-model="sugVal" :auto-size="{ minRows: 5, maxRows: 8 }" />
    </a-modal>
  </div>
</template>

<script>
import imgModal from "@/components/img_modal"; //弹窗组件
import bus from "../bus.js"; //中间件
import { renounce_check } from "@/api/work"; //报审机构
import Drama from "../drama"; //产品组件
import {
  check_check,
  del_check_info,
  save_check,
  check_detail,
} from "@/api/organization";
import {
  specialist_info, //获取专家审核内容
  specialist_detail, //查看专家审核内容
  get_specialist_label_list, //获取专家审核标签
  get_specialist_premission, //获取专家审核权限
  age_specialist_bind_label, //专家为剧本绑定标签
  specialist_approved, //专家完成审核
  save_delete_content, //专家删除内容审核
  approved_number, //专家建议完成统计
  suggest, //专家提交全局建议
  spe_first_detail,//专家查看一次剧本信息
} from "@/api/association";
export default {
  name: "components_audit",
  props: {
    auditData: {
      type: Object,
      default: {},
    },
    isAudit: {
      type: Boolean,
      default: false,
    },
  },
  components: { Drama, imgModal },
  data() {
    return {
      paramsVal: [],
      previewVisible: false, //图片弹窗
      //图片弹窗需要传入的地址
      isActive: 0,
      botAudit: [], //AI审核
      audit: [], //展示的审核内容
      auditAll: [], //审核内容池子
      audit1: [], //文本人工审核内容
      audit2: [], //图片人工审核内容
      audit3: [], //视频人工审核内容
      audit4: [], //音频人工审核内容
      audit5: [], //标题人工审核内容
      pageType: "",
      auditor_id: "", //选中机构id
      auditor_list: [], //机构列表
      auditUser_id: "", //选中人员id
      audit_user_list: [], //人员列表
      // paramsVal: [], //路由传递过来的数据，暂存local
      visible: false, //选中文字弹窗
      setModal: false, //提交适龄评测
      setModal1: false, //完成审核
      opinion: "", //审核意见内容
      errorVal: "", //选中的文字注入输入框
      causeVal: "", //选中文字异常原因
      remarkVal: "", //备注说明
      discussion_note: "", //建议理由
      confirmLoading: false, //选中文字弹窗_提交按钮
      viewH: "", //tab页动态高度
      previewImage: "", //图片弹窗需要传入的地址
      wordText: "", //读取文档视图
      arr: this.violate, //复用
      modalFlag: true, //区分文档弹窗和图片视频弹窗
      hrefId: "", //判断是否有返回列表按钮
      /* api接口获取到的内容 */
      viewDatas: false, //页面数据
      script_info: "", //基础信息
      script_manuals: "", //文本信息
      script_pic: "", //图片信息
      script_video: "", //视频信息
      script_voice: "", //音频信息
      showEdit: false, //修改文件弹窗
      /* form表单提交 */
      form: this.$form.createForm(this, { name: "coordinated" }),
      fileList: [], //上传文本
      fileList1: [], //上传图片
      fileList2: [], //上传视频
      fileList3: [], //上传音频
      pageId: "", //页面id
      showHide: false, //多余内容展示
      tipsH: false, //多余内容高度
      /* 质检页面 */
      auditTabs: 0, //切换tab页
      qcAudit: [], //质检信息页
      qcAuditAll: [], //质检内容池子
      qcAudit1: [], //文本人工质检内容
      qcAudit2: [], //图片人工质检内容
      qcAudit3: [], //视频人工质检内容
      qcAudit4: [], //音频人工质检内容
      qcAudit5: [], //标题人工质检内容
      /* 专家页面 */
      authority: [], //专家审核权限
      authority1: false, //专家文本权限
      authority2: false, //专家文本权限
      authority3: false, //专家文本权限
      authority4: false, //专家文本权限
      authority5: false, //专家文本权限
      authority6: false, //专家标题权限
      isAuthority: "", //专家首页标识
      classifyArr: [], //归类标签列表
      classify: [], //选择的归类标签
      ageLabel: [], //适龄标签列表
      ageArr: "", //选择的适龄标签
      specialist_edit: false, //判断专家自己的修改
      specialist_number: {
        total: 0,
        add: 0,
        edit: 0,
        delete: 0,
      }, //专家统计审核数量
      sugModal: false, //专家建议弹窗
      sugVal: "",
      //判断专家查看一次剧本
      cutFlag:false,
      reloadDate:0,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.paramsVal = this.auditData;
    // this.paramsVal = this.$route.params;
    this.specialist_premission();

    /* if (localStorage.sessionParams) {
      this.paramsVal = JSON.parse(localStorage.sessionParams);
    } else {
      if (JSON.stringify(this.$route.params) != "{}") {
        this.propsVal();
      }
    }
    if (this.paramsVal.type == "audit") {
      this.pageType = true;
    } else {
      this.pageType = false;
    } */
    console.log("路由传递过来的数据，暂存local", this.paramsVal);
    //中间件bus取值
    bus.$off("getDelFun");
    bus.$on("getDelFun", this.getDelFuns);
  },
  mounted() {},
  methods: {
    /* -------------------------------------------------公共方法------------------------------------------------- */
    //返回上一页
    goback() {
      this.$emit("setIsAudit", true, null, this.paramsVal);
      // this.isAudit = true
    },
    //获取中间件bus的方法
    getDelFuns(items) {
      console.log("itemmmmmmmmmmmmmmmmm", items);
      let index = 0;
      this.audit.map((item, i) => {
        if (item.id == items.id) {
          return (index = i);
        }
      });
      console.log("indexxxxxxxxx", index);
      this.del_check(items, index);
    },
    //展开收起多余的内容
    isShowTips(index) {
      console.log("this.audit[index]", this.audit[index]);
      console.log(index);
      let data = [];
      this.audit.map((item) => {
        data.push(item);
      });
      if (data[index].showHide) {
        data[index].showHide = false;
      } else {
        data[index].showHide = true;
      }
      this.audit = data;
    },
    //预览下载二维码
    openQrcode(url) {
      window.open(url);
    },
    /* -------------------------------------------------审核机构/协会------------------------------------------------- */
    //查看一次剧本详情
    cutBtn() {
      this.$store.commit("spinning", true);
      if(!this.cutFlag){
      spe_first_detail({ id: this.paramsVal.id,user_id: this.$store.state.user.id,is_second:0 })
        .then((res) => {
          if (res) {
            this.viewDatas = res.data ? res.data : "";
            this.script_info = res.data.script_info ? res.data.script_info : "";
            this.script_manuals = res.data.script_manuals
              ? res.data.script_manuals
              : "";
            this.script_pic = res.data.script_pic ? res.data.script_pic : "";
            this.script_video = res.data.script_video
              ? res.data.script_video
              : "";
            this.script_voice = res.data.script_voice
              ? res.data.script_voice
              : "";
            this.botAudit = res.data.check_script_info_ai;
            this.auditAll = res.data.check_script_info_man;
            this.auditAll.map((item) => {
              if (this.paramsVal.self) {
                if (
                  (item.unusual_type_name
                    ? item.unusual_type.split("-")[0] == 25
                    : false) &&
                  item.is_show == 1
                ) {
                } else {
                  switch (item.type) {
                    case 1:
                      console.log(
                        "需要显示的数据+++++++++++++++++++++++++++++",
                        item
                      );
                      item.showHide = true;
                      this.audit1.push(item);
                      break;
                    case 2:
                      this.audit2.push(item);
                      break;
                    case 3:
                      this.audit3.push(item);
                      break;
                    case 4:
                      this.audit4.push(item);
                      break;
                    case 5:
                      this.audit.push(item);
                      this.audit5.push(item);
                      break;
                  }
                }
              } else {
                switch (item.type) {
                  case 1:
                    item.showHide = true;
                    this.audit1.push(item);
                    break;
                  case 2:
                    this.audit2.push(item);
                    break;
                  case 3:
                    this.audit3.push(item);
                    break;
                  case 4:
                    this.audit4.push(item);
                    break;
                  case 5:
                    this.audit.push(item);
                    this.audit5.push(item);
                    break;
                }
              }
            });
            this.paramsVal.type = "examine"
            this.cutFlag = true
            this.reloadDate = 1
            this.$store.commit("spinning", false);
          } else {
            console.log("协会详情请求的接口报错1", res);
            this.$emit("setIsAudit", true, "reload");
          }
        })
        .catch((err) => {
          console.log("协会详情请求的接口报错1", res);
          this.$emit("setIsAudit", true, "reload");
        });
      }else{
        this.paramsVal.type = null
        this.getCheck_check()
      }
    },

    //获取数据
    getCheck_check() {
      this.$store.commit("spinning", true);
      if (this.paramsVal.is_finish) {
        specialist_detail({
          id: this.paramsVal.id,
          user_id: this.$store.state.user.id,
          is_second: this.paramsVal.is_second,
        })
          .then((res) => {
            console.log(res);
            if (res) {
              this.viewDatas = res.data ? res.data : "";

              this.script_info = res.data.script_info
                ? res.data.script_info
                : "";
              this.script_manuals = res.data.script_manuals
                ? res.data.script_manuals
                : "";
              this.script_pic = res.data.script_pic ? res.data.script_pic : "";
              this.script_video = res.data.script_video
                ? res.data.script_video
                : "";
              this.script_voice = res.data.script_voice
                ? res.data.script_voice
                : "";
              this.botAudit = res.data.check_script_info_ai;
              this.qcAuditAll = res.data.check_script_info_man_specialist;
              this.qcAuditAll.map((item) => {
                switch (item.type) {
                  case 1:
                    item.showHide = true;
                    this.qcAudit1.push(item);
                    this.authority1 ? (item.showBtn = true) : "";
                    break;
                  case 2:
                    this.qcAudit2.push(item);
                    this.authority2 ? (item.showBtn = true) : "";
                    break;
                  case 3:
                    this.qcAudit3.push(item);
                    this.authority3 ? (item.showBtn = true) : "";
                    break;
                  case 4:
                    this.qcAudit4.push(item);
                    this.authority4 ? (item.showBtn = true) : "";
                    break;
                  // case 5:
                  //   this.qcAudit.push(item);
                  //   this.qcAudit5.push(item);
                  //   break;
                }
              });
              this.auditAll = res.data.check_script_info_man;
              this.auditAll.map((item) => {
                switch (item.type) {
                  case 1:
                    item.showHide = true;
                    this.audit1.push(item);
                    this.authority1 ? (item.showBtn = true) : "";
                    console.log("this.authority1", this.authority1);
                    break;
                  case 2:
                    this.audit2.push(item);
                    this.authority2 ? (item.showBtn = true) : "";
                    break;
                  case 3:
                    this.audit3.push(item);
                    this.authority3 ? (item.showBtn = true) : "";
                    break;
                  case 4:
                    this.audit4.push(item);
                    this.authority4 ? (item.showBtn = true) : "";
                    break;
                  case 5:
                    // this.authority5 ? item.showBtn = true : ''
                    this.audit.push(item);
                    this.audit5.push(item);
                    break;
                }
              });
              
              this.$store.commit("spinning", false);
            } else {
              this.$emit("setIsAudit", true, "reload");
            }
          })
          .catch((err) => {
            this.$emit("setIsAudit", true, "reload");
          });
      } else {
        specialist_info({
          id: this.paramsVal.id,
          user_id: this.$store.state.user.id,
          is_second: this.paramsVal.is_second,
        })
          .then((res) => {
            console.log(res);
            if (res) {
              this.viewDatas = res.data ? res.data : "";
              this.script_info = res.data.script_info
                ? res.data.script_info
                : "";
              this.script_manuals = res.data.script_manuals
                ? res.data.script_manuals
                : "";
              this.script_pic = res.data.script_pic ? res.data.script_pic : "";
              this.script_video = res.data.script_video
                ? res.data.script_video
                : "";
              this.script_voice = res.data.script_voice
                ? res.data.script_voice
                : "";
              this.botAudit = res.data.check_script_info_ai;
              this.qcAuditAll = res.data.check_script_info_man_specialist;
              this.audit = []
                this.audit1 = []
                this.audit2 = []
                this.audit3 = []
                this.audit4 = []
                this.audit5 = []
              this.qcAuditAll.map((item) => {
                switch (item.type) {
                  case 1:
                    item.showHide = true;
                    this.qcAudit1.push(item);
                    this.authority1 ? (item.showBtn = true) : "";
                    break;
                  case 2:
                    this.qcAudit2.push(item);
                    this.authority2 ? (item.showBtn = true) : "";
                    break;
                  case 3:
                    this.qcAudit3.push(item);
                    this.authority3 ? (item.showBtn = true) : "";
                    break;
                  case 4:
                    this.qcAudit4.push(item);
                    this.authority4 ? (item.showBtn = true) : "";
                    break;
                  // case 5:
                  //   this.qcAudit.push(item);
                  //   this.qcAudit5.push(item);
                  //   break;
                }
              });
              this.auditAll = res.data.check_script_info_man;
              this.auditAll.map((item) => {
                switch (item.type) {
                  case 1:
                    item.showHide = true;
                    this.audit1.push(item);
                    this.authority1 ? (item.showBtn = true) : "";
                    console.log("this.authority1", this.authority1);
                    break;
                  case 2:
                    this.audit2.push(item);
                    this.authority2 ? (item.showBtn = true) : "";
                    break;
                  case 3:
                    this.audit3.push(item);
                    this.authority3 ? (item.showBtn = true) : "";
                    break;
                  case 4:
                    this.audit4.push(item);
                    this.authority4 ? (item.showBtn = true) : "";
                    break;
                  case 5:
                    // this.authority5 ? item.showBtn = true : ''
                    this.audit.push(item);
                    this.audit5.push(item);
                    break;
                }
              });
              this.cutFlag = false
              this.reloadDate = 0
              this.$store.commit("spinning", false);
            } else {
              this.$emit("setIsAudit", true, "reload");
            }
          })
          .catch((err) => {
            this.$emit("setIsAudit", true, "reload");
          });
      }
    },
    //修改内容审核
    editModal(item, specialist) {
      // if(id){return this.$refs.drama.showModal(id, item,'edit')}
      if (specialist) {
        this.$refs.drama.specialist_edit = true;
      } else {
        this.$refs.drama.specialist_edit = false;
      }
      this.$refs.drama.showModal(1, item, "edit", null, null, specialist);
    },

    //删除内容审核
    del_check(item, index) {
      let that = this;
      this.$confirm({
        title: "删除提示",
        content: "确定要删除这条内容审核吗？",
        onOk() {
          return new Promise((resolve, reject) => {
            // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            del_check_info({
              id: item.id,
              script_id: item.script_id,
              role_id: that.$store.state.user.role_id,
              user_id: that.$store.state.user.id,
              admin_id: that.viewDatas.script_info.admin_id,
              works_name: that.viewDatas.script_info.works_name,
              user_name: that.$store.state.user.name,
              script_id: that.viewDatas.script_info.id,
            })
              .then((res) => {
                console.log(item);
                console.log(res);
                if (res) {
                  that.$message.success(res.message);
                  that.del_check_fun(item, index);
                  that.$refs.drama.del_displayResult(item, index);
                  switch (item.type) {
                    case 1:
                      that.viewDatas.manuals_unusual_count--;
                      break;
                    case 2:
                      that.viewDatas.pic_unusual_count--;
                      break;
                    case 3:
                      that.viewDatas.video_unusual_count--;
                      break;
                    case 4:
                      that.viewDatas.voice_unusual_count--;
                      break;
                    case 5:
                      that.audit_5 = [];
                      // that.audit = [];
                      break;
                  }
                  if (res.data) {
                    that.getAudit(
                      res.data,
                      "edit",
                      item.type == 5 ? item : null
                    );
                  }
                  resolve();
                }
              })
              .catch((err) => {
                reject();
              });
          }); /* .catch(() => console.log("Oops errors!")).finally(() => {
               resolve()
            }) */
        },
        onCancel() {},
      });
    },
    //删除合议内容
    del_content(item, index) {
      const that = this;
      this.$confirm({
        content: "确定要删除这条合议内容吗?",
        onOk() {
          return new Promise((resolve, reject) => {
            // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            save_delete_content({ id: item.id }).then((res) => {
              if (res) {
                that.$message.success({
                  content: res.message,
                  duration: 2.5,
                });
                that.audit.map((items) => {
                  if (items.id == item.id) {
                    items.specialist_result = 0;
                    return;
                  }
                });
                // that.audit.splice(index,1,items)
                switch (item.type) {
                  case 1:
                    that.audit1.map((items, index) => {
                      if (item.id == items.id) {
                        that.audit1[index].specialist_result = 0;
                        // that.audit1.splice(index,1,items)
                        return;
                      }
                    });
                    break;
                  case 2:
                    that.audit2.map((items, index) => {
                      if (item.id == items.id) {
                        that.audit2[index].specialist_result = 0;
                        return;
                      }
                    });
                    break;
                  case 3:
                    that.audit3.map((items, index) => {
                      if (item.id == items.id) {
                        that.audit3[index].specialist_result = 0;
                        return;
                      }
                    });
                    break;
                  case 4:
                    that.audit4.map((items, index) => {
                      if (item.id == items.id) {
                        that.audit4[index].specialist_result = 0;
                        return;
                      }
                    });
                    break;
                }
                resolve();
                // that.$emit("setIsAudit",true,"reload");
              } else {
                reject();
              }
            });
          });
        },
        cancelText: "取消",
        onCancel() {
          that.$destroyAll();
        },
      });
    },
    //删除方法
    del_check_fun(items, index) {
      this.audit.splice(index, 1);
      let arr = [];
      switch (items.type) {
        case 1:
          arr = this.audit1;
          break;
        case 2:
          arr = this.audit2;
          break;
        case 3:
          arr = this.audit3;
          break;
        case 4:
          arr = this.audit4;
          break;
        case 5:
          arr = this.audit5;
          break;
      }
      arr.map((item, index) => {
        if (item.id == items.id) {
          arr.splice(index, 1);
          return;
        }
      });
    },
    //切换tab切换右侧人工审核信息
    changeTabs(type) {
      console.log(type);
      switch (type) {
        case 0:
          this.audit = this.audit5;
          break;
        case 1:
          this.cutSubTab(this.viewDatas.script_manuals[0].id);
          break;
        case 2:
          this.audit = this.audit2;
          break;
        case 3:
          this.audit = this.audit3;
          break;
        case 4:
          this.audit = this.audit4;
          break;
      }
    },
    //切换剧本tab切换右侧人工审核信息
    cutSubTab(type) {
      this.cutSubTabFun(type);
    },
    //cutSubTabFun
    cutSubTabFun(type) {
      let arr = [];
      let arr1 = [];
      this.audit = [];
      this.qcAudit = [];
      this.audit1.map((item) => {
        if (item.material_id == type) {
          // item.showHide = true
          arr.push(item);
        }
      });
      this.audit = arr;

      /* this.qcAudit1.map((item) => {
        if (item.material_id == type) {
          // item.showHide = true
          arr1.push(item);
        }
      });
      this.qcAudit = arr1; */
    },
    //子组件返回的数据
    getAudit(items, edit, audit5) {
      items.showBtn = true;
      if (edit) {
        console.log(items);
        this.audit.map((item, index) => {
          console.log(item);
          if (items.id == item.id) {
            this.audit.splice(index, 1, items);
            return;
          }
        });
        if (items.type == 1) {
          this.audit1.map((item, index) => {
            if (items.id == item.id) {
              this.audit1.splice(index, 1, items);
              return;
            }
          });
        }
        if (audit5) {
          this.audit5 = audit5;
        }
      } else {
        console.log(items);
        if (items.type == 5) {
          this.audit = [];
        }
        this.audit.push(items);
        if (items.type == 1) {
          // item.showHide = true
          this.audit1.push(items);
        }
      }
    },
    //接收子组件选中的东西----test
    auditList(val) {
      this.audit.push(val);
      setTimeout(() => {
        this.$refs.drama.displayResult();
      }, 200);
    },
    //接收并保存传递过来的参数
    propsVal() {
      console.log("params", this.$route.params);
      this.paramsVal = this.$route.params;
      localStorage.setItem("sessionParams", JSON.stringify(this.$route.params));
    },
    test(val) {
      console.log(val);
      this.isActive = val;
    },
    //判断链接格式
    isHttp(url) {
      let str = url.substring(url.length - 3);
      if (str != "mp4" && str != "mp3") {
        return "img";
      } else if (str != "mp3") {
        return "mp4";
      } else {
        return "mp3";
      }
    },
    //图片弹窗子传父
    flags(flag) {
      console.log(flag);
      this.previewVisible = flag;
    },
    //点击弹窗
    showModal(url) {
      this.previewVisible = true;
      this.previewImage = url;
    },

    //协会审核完成
    finishBtn() {
      this.setModal1 = true;
      approved_number({
        id: this.script_info.id,
        is_second: this.script_info.is_second,
      }).then((res) => {
        if (res) {
          this.specialist_number = res.data;
        }
      });
    },
    //协会审核完成方法
    finishApi() {
      this.confirmLoading = true;
      const that = this;
      specialist_approved({
        id: that.script_info.id,
        admin_id: that.$store.state.user.id,
        ids: that.authority,
        is_second: that.script_info.is_second,
      }).then((res) => {
        if (res) {
          that.$message.success({
            content: res.message,
            duration: 2.5,
          });
          that.confirmLoading = false;
          that.$emit("setIsAudit", true, "reload");
          resolve();
        } else {
          this.confirmLoading = false;
          reject();
        }
      });
    },

    /* -----------------------------------------------专家功能-------------------------------------------- */
    //整体审核建议弹窗
    showSug() {
      this.sugModal = true
      if (this.script_info.is_second) {
        this.sugVal = this.script_info.specialist_second_suggest;
      } else {
        this.sugVal = this.script_info.specialist_first_suggest;
      }
    },
    //获取专家审核权限
    specialist_premission() {
      get_specialist_premission("script_id=" + this.paramsVal.id)
        .then((res) => {
          if (res) {
            res.data.map((item) => {
              switch (item) {
                case 1:
                  this.authority1 = true;
                  break;
                case 2:
                  this.authority2 = true;
                  break;
                case 3:
                  this.authority3 = true;
                  break;
                case 4:
                  this.authority4 = true;
                  break;
                case 5:
                  this.authority5 = true;
                  break;
                case 6:
                  this.authority6 = true;
                  break;
              }
            });
            this.authority = res.data.join(",");
            if (res.data.length > 1) {
              this.isAuthority = res.data[0];
            } else {
              this.isAuthority = res.data;
            }
            this.getCheck_check();
          }
        })
        .catch((err) => {});
    },
    //获取标签列表判断
    get_label_list(type) {
      this.setModal = true;

      if (this.authority.indexOf("5,6") != -1) {
        for (let i = 5; i < 7; i++) {
          // const element = array[i];
          if (type == "get") {
            this.get_label_list_fun(i);
          } else {
            this.upLoadLabel(i);
          }
        }
      } else if (this.authority.indexOf("5") != -1) {
        if (type == "get") {
          this.get_label_list_fun(5);
        } else {
          this.upLoadLabel(5);
        }
      } else if (this.authority.indexOf("6") != -1) {
        if (type == "get") {
          this.get_label_list_fun(6);
        } else {
          this.upLoadLabel(6);
        }
      }
    },
    //获取标签列表方法
    get_label_list_fun(val) {
      get_specialist_label_list(`label_type=${val == 5 ? 1 : 2}`)
        .then((res) => {
          if (res) {
            console.log(res);
            if (val == 5) {
              this.classifyArr = res.data;
            } else {
              this.ageLabel = res.data;
            }
          } else {
          }
        })
        .catch((err) => {});
    },
    //选择适龄标签
    onChange(checkedValues) {
      console.log("checked = ", checkedValues);
      this.ageArr = checkedValues;
    },
    //选择分类标签
    onChange1(checkedValues) {
      console.log("checked = ", checkedValues);
      this.classify = checkedValues;
    },
    //专家为剧本绑定标签
    upLoadLabel(val) {
      const that = this;
      this.$confirm({
        content: "确定完成本次提交吗？",
        onOk() {
          return new Promise((resolve, reject) => {
            let data = {
              script_id: that.script_info.id,
              // label_type:val==5?1:2,
              bind_label_list:
                val == 5 ? that.classify.join(",") : that.ageArr.toString(),
              remark: that.remarkVal,
            };
            console.log(data);
            setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            age_specialist_bind_label(data).then((res) => {
              if (res) {
                that.$message.success({
                  content: res.message,
                  duration: 2.5,
                });
                that.$emit("setIsAudit", true, "reload");
                // that.zjAudit.splice(index,1)
                resolve();
                // that.$router.push("/work/drama")
                // that.goback()
              } else {
                reject();
              }
            });
          });
        },
        cancelText: "取消",
        onCancel() {
          that.$destroyAll();
        },
      });
    },
    //专家整体审核意见
    suggestApi() {
      const data = {
        id: this.script_info.id,
        is_second: this.script_info.is_second,
        suggest: this.sugVal?this.sugVal:'',
      };
      this.confirmLoading = true;
      suggest(data)
        .then((res) => {
          if (res) {
            this.$message.success(res.message);
            if (this.script_info.is_second) {
              this.script_info.specialist_second_suggest = this.sugVal;
            } else {
              this.script_info.specialist_first_suggest = this.sugVal;
            }
            console.log(this.script_info);
            this.sugModal = false;
            this.sugVal = "";
            this.confirmLoading = false;
          } else {
            this.$message.error(res.message);
            this.confirmLoading = false;
          }
        })
        .catch((err) => {
          this.$message.error(res.message);
          this.confirmLoading = false;
        });
    },
    /* -----------------------------------------------质检功能-------------------------------------------- */
    //切换审核信息列表
    auditCallback(val) {
      this.auditTabs = val;
    },
  },
  destroyed() {
    if (localStorage.sessionParams) {
      localStorage.removeItem("sessionParams");
    }
  },
};
</script>

<style scoped lang="less">
#audit {
  background: #fff;
  overflow: auto;
}
.auditList {
  .ant-list {
    margin: 15px;
  }
  .ant-list-item {
    &:hover {
      border-bottom: 2px solid #40a9ff;
      cursor: pointer;
    }
  }
}

.active {
  border-bottom: 2px solid #40a9ff;
}
.ant-col {
  height: 100%;
}
.title {
  font-size: 18px;
  font-weight: bold;
  line-height: 43px;
  padding: 0 15px;
  border-bottom: 1px solid #e8e8e8;
}
.header {
  padding: 10px 15px;
}
.fontSize {
  font-size: 20px;
  font-weight: 500;
  margin-left: 20px;
}
.tips {
  font-weight: bold;
  color: #40a9ff;
}

//展示折叠
.hidetips {
  overflow: hidden;
  display: inline-block;
  height: 40px;
}
.showtips {
  overflow: hidden;
  display: inline-block;
  height: 40px;
}

.tipsfix,
.tipsfix1 {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 50px;
  background-color: #fff;
  line-height: 16px;
  text-align: center;
}
.tipsfix1 {
  // width:;
}
/* .itemClass{
  padding:5px;

  border: 1px solid #ccc;
} */

/deep/ .ant-list-item {
  padding: 10px 0 0 0;
}

/deep/ .ant-card-head-title {
  font-size: 18px;
}
/deep/ .ant-modal-body,
/deep/ .ant-modal-header {
  font-size: 24px;
}
/deep/ .ant-btn {
  font-size: 24px !important;
  height: 48px !important;
}
/deep/ .ant-input {
  font-size: 24px;
}
</style>
